import { useMemo } from 'react';

import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacet } from '#/modules/search/types/SearchFacet';

import { internshipKeywordsFacet } from './searchFacets/internshipKeywordsFacet';
import { localeFacet } from './searchFacets/localeFacet';
import { locationTypeFacet } from './searchFacets/locationTypeFacet';
import { orgAreasOfFocusFacet } from './searchFacets/orgAreasOfFocusFacet';
import { orgTypeFacet } from './searchFacets/orgTypeFacet';
import { paymentFacet } from './searchFacets/paymentFacet';
import { recencyFacet } from './searchFacets/recencyFacet';

export function unstableInternshipSearchFacets(i18n: I18nFn) {
  return [
    locationTypeFacet(i18n),
    internshipKeywordsFacet(i18n),
    orgAreasOfFocusFacet(i18n),
    orgTypeFacet(i18n),
    paymentFacet(i18n),
    localeFacet(i18n),
    recencyFacet(i18n),
  ] satisfies SearchFacet[];
}

/**
 * Only use this function if the code consuming the output does not rely on a stable object.
 *
 * If it does, use the hook instead
 */

export function useSearchFacetsInternship(i18n: I18nFn) {
  const internshipSearchFacets = useMemo(
    () => unstableInternshipSearchFacets(i18n),
    [i18n],
  );

  return { internshipSearchFacets };
}
